import { routes } from "./routes";
import Home from "../views/Dashboard/Home/home";
import CollectionList from "../views/Dashboard/collection/CollectionList";
import OverviewList from "../views/Dashboard/overview/OverviewList";
import ContractWrapper from "../views/Dashboard/contract/ContractWrapper";
import SettlementList from "../views/Dashboard/settlement/SettlementList";
import ExpenseView from "../views/Dashboard/reports/expenses/ExpenseView";
import PassRevenueView from "../views/Dashboard/reports/passRevenue/passRevenueView";
import CardCollection from "../views/Dashboard/card-collection/CardCollection";
import BusDetail from "../views/Dashboard/bus-detail/BusDetail";
import DateDetail from "../views/Dashboard/date-detail/DateDetail";
import DateDetailOperator from "../views/Dashboard/date-detail/DateDetailOperator";
import VehicleContract from "../views/Dashboard/contract/vehicleContracts/vehicleContractList";
import OperatorSettlement from "../views/Dashboard/settlement/operatorSettlement/OperatorSettlement";
import PreviousSettlementDetail from "../views/Dashboard/settlement/operatorSettlement/PreviousSettlementDetail";
import OperatorView from "../views/Dashboard/operator-view/OperatorView";
import BalanceLoaded from "../views/Dashboard/operator-view/BalanceLoaded";
import BalanceSpent from "../views/Dashboard/operator-view/BalanceSpent";
import OperatorSettlementTab from "../views/Dashboard/operator-view/OperatorSettlementTab";
import OperatorContractTab from "../views/Dashboard/operator-view/OperatorContractTab";
import OperatorViewVehicleDetail from "../views/Dashboard/operator-view/OperatorViewVehicleDetail";
import DistanceReportView from "../views/Dashboard/reports/distance-report/DistanceReportView";
import ReportView from "../views/Dashboard/reports/ReportView";
import mobileTicketDetails from "../views/Dashboard/reports/mobile-ticket/mobileTicketDetails";
import DistanceReport from "../views/Dashboard/reports/distance-report/DistanceReport";
import MobileTicketReport from "../views/Dashboard/reports/mobile-ticket/MobileTicketReport";
import MobileSettlementDetails from "../views/Dashboard/reports/mobile-ticket/mobileSettlementDetail";
import PreviousSettlementDetails from "../views/Dashboard/settlement/operatorSettlement/PreSettleDropDown";
import PassReport from "../views/Dashboard/reports/pass/PassReport";
import passDetails from "../views/Dashboard/reports/pass/passDetails";
import PassRevenueProductsDistribution from "../views/Dashboard/reports/pass/PassRevenueProductsDistribution";
import PassSettlementReport from "../views/Dashboard/reports/passSettlement/PassSettlementReport";
import PassSettlementSettlementDetails from "../views/Dashboard/reports/passSettlement/passSettlementDetail";
import OperatorWiseReport from "../views/Dashboard/reports/operator-wise-report/OperatorWiseReport";
import BulkEditGrossContribution from "../views/Dashboard/reports/bulk-edit-gross-contribution/BulkEditGrossContribution";
import ReportsModule from "../views/Dashboard/reports/reports-module/ReportsModule";
import AdminConfig from "../views/Dashboard/AdminConfig/AdminConfig";
import CityConfig from "../views/Dashboard/AdminConfig/CityConfig";
import OperatorConfig from "../views/Dashboard/reports/operatorConfig/OperatorConfig";

export const routeComponent = {
  [routes.HOME]: Home,
  [routes.OVERVIEW]: OverviewList,
  [routes.COLLECTION]: CollectionList,
  [routes.CONTRACT]: ContractWrapper,
  [routes.CARDCOLLECTION]: CardCollection,
  [routes.SETTLEMENT]: SettlementList,
  [routes.BUSDETAIL]: BusDetail,
  [routes.DATE_DETAIL_OPERATOR]: DateDetailOperator,
  [routes.DATEDETAIL]: DateDetail,
  [routes.VEHICLECONTRACT]: VehicleContract,
  [routes.OPERATORVIEW]: OperatorView,
  [routes.BALANCE_LOADED]: BalanceLoaded,
  [routes.DAY_WISE_BALANCE_LOADED]: BalanceLoaded,
  [routes.BALANCE_SPENT]: BalanceSpent,
  [routes.DAY_WISE_BALANCE_SPENT]: BalanceSpent,
  [routes.OPERATOR_VEHICLE_DETAIL]: OperatorViewVehicleDetail,
  [routes.OPERATOR_SETTLEMENT_TAB]: OperatorSettlementTab,
  [routes.OPERATOR_CONTRACT_TAB]: OperatorContractTab,
  [routes.PREVIOUS_SETTLEMENT_DETAIL]: PreviousSettlementDetail,
  [routes.OPERATORSETTLEMENT]: OperatorSettlement,
  [routes.DISTANCE_REPORT_VIEW]: DistanceReportView,
  [routes.MOBILE_TICKET_DETAILS]: mobileTicketDetails,
  [routes.REPORT]: ReportView,
  [routes.DISTANCE_REPORT]: DistanceReport,
  [routes.MOBILE_TICKET_REPORT]: MobileTicketReport,
  [routes.MOBILE_TICKET_RESIDUAL_SETTLEMENT]: MobileSettlementDetails,
  [routes.PREVIOUS_SETTLEMENT_DETAILS]: PreviousSettlementDetails,
  [routes.PASS_REPORT]: PassReport,
  [routes.PASS_DETAILS]: passDetails,
  [routes.PASS_REVENUE_DISTRIBUTION]: PassRevenueProductsDistribution,
  [routes.PASS_SETTLEMENT_REPORT]: PassSettlementReport,
  [routes.PASS_SETTLEMENT_RESIDUAL_SETTLEMENT]: PassSettlementSettlementDetails,
  [routes.REPORTS_MODULE]: ReportsModule,
  [routes.OPERATOR_WISE_REPORT]: OperatorWiseReport,
  [routes.BULK_EDIT_GROSS_CONTRIBUTION]: BulkEditGrossContribution,
  [routes.EXPENSES]: ExpenseView,
  [routes.ADMIN_CONFIG]: AdminConfig,
  [routes.ADMIN_CITY_CONFIG]: CityConfig,
  [routes.PASS_REVENUE]: PassRevenueView,
  [routes.OPERATOR_CONFIG]: OperatorConfig,
  [routes.CITY_CONFIG]: AdminConfig,
};
